const stockMatchOptionType = {
  unknown: 'Unknown',
  standard: 'Standard',
  additional: 'Additional',
  aditional: 'Aditional',
}
export default stockMatchOptionType
